import { Button, Card, Typography } from '@mui/joy';
import { MdError } from 'react-icons/md';

interface ErrorFallbackProps {
  error: unknown;
  resetErrorBoundary: () => void;
}

/**
 * Shared error fallback UI for react-error-boundary.
 * Renders a card with the error message and a retry button.
 */
export const ErrorFallback = ({ error, resetErrorBoundary }: ErrorFallbackProps) => {
  return (
    <Card
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '300px',
        gap: 2,
        p: 4,
        mx: 'auto',
        maxWidth: '600px',
        mt: 8,
      }}
    >
      <MdError size={48} color='var(--joy-palette-danger-500)' />
      <Typography level='h4' textAlign='center'>
        Something went wrong
      </Typography>
      <Typography level='body-md' color='neutral' textAlign='center'>
        {error instanceof Error ? error.message : 'An unexpected error occurred. Please try again.'}
      </Typography>
      <Button variant='solid' onClick={resetErrorBoundary}>
        Try again
      </Button>
    </Card>
  );
};
